import { FetchAttr } from '../types';
import { postData } from '../utils';
import { PostDrugRequest, PostDrugResponse } from './postDrugSearch';

// This request should be used to load filters object for postDrugSearch API
// We load filters and other data separately to increase page performance
// This API utilizes the same response and request payload types for simplification
const postDrugSearchFilters = async (
  requestObj: PostDrugRequest,
  attr?: FetchAttr
): Promise<PostDrugResponse> => {
  const response = await postData(`drug/search/filters`, requestObj, attr);
  return response;
};

export default postDrugSearchFilters;
